module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Fischbach-Goeslikon-80f94a7f81fa355d1fa3cc567c248762.svg";